import React from 'react'

export function SearchIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#43D0A3"
        fillRule="evenodd"
        d="M1.25 10.5a9.25 9.25 0 1118.5 0 9.25 9.25 0 01-18.5 0zm9.25-7.75a7.75 7.75 0 100 15.5 7.75 7.75 0 000-15.5z"
        clipRule="evenodd"
      />
      <path
        fill="#43D0A3"
        fillRule="evenodd"
        d="M16.08 16.08a.75.75 0 011.061 0l4.243 4.243a.75.75 0 01-1.06 1.06l-4.244-4.242a.75.75 0 010-1.06z"
        clipRule="evenodd"
      />
    </svg>
  )
}
